// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1cee00e6","455":"c60622fb","977":"f6775440"}[chunkId] + ".chunk.js";
};